import config from '../config/origin';
import { toast } from 'react-toastify';

const API_KEY = config.apiKey;

let resolvedBaseUrl = config.apiBaseUrl;
try {
  resolvedBaseUrl = /^https?:\/\//.test(config.apiBaseUrl)
    ? config.apiBaseUrl
    : new URL(config.apiBaseUrl, window.location.origin).toString();
} catch (_) {
  // ignore URL resolution errors, keep original
}

console.log('[NodeSpace] Conectando a API base:', resolvedBaseUrl, `env: ${config.env}`);

const getToken = () => localStorage.getItem('authToken');

const buildHeaders = (extraHeaders = {}) => {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(API_KEY ? { 'x-api-key': API_KEY, 'x-api-code': API_KEY } : {}),
    ...extraHeaders,
  };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return headers;
};

const buildUrl = (path, query = undefined) => {
  const base = config.apiBaseUrl.replace(/\/$/, '');
  const cleanPath = String(path || '').replace(/^\//, '');
  const full = `${base}/${cleanPath}`;
  const url = /^https?:\/\//.test(full)
    ? new URL(full)
    : new URL(full, window.location.origin);
  if (query && typeof query === 'object') {
    Object.entries(query).forEach(([k, v]) => {
      if (v !== undefined && v !== null) url.searchParams.set(k, String(v));
    });
  }
  const finalUrl = url.toString();
  console.log('[NodeSpace] Request URL:', finalUrl);
  return finalUrl;
};

const handleResponse = async (res) => {
  const contentType = res.headers.get('content-type') || '';
  const isJson = contentType.includes('application/json');
  const data = isJson ? await res.json().catch(() => null) : await res.text();

  if (res.status === 401) {
    try {
      // Limpiar información básica de sesión
      localStorage.removeItem('authToken');
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('currentUser');
      localStorage.removeItem('currentStation');
      localStorage.removeItem('currentNode');
    } catch (_) {}

    try {
      toast.error('Tu sesión se ha vencido, vuelve a iniciar sesión');
    } catch (_) {}

    try {
      window.location.href = '/';
    } catch (_) {}
  }

  if (!res.ok) {
    const error = new Error((data && data.message) || res.statusText || 'Request error');
    error.status = res.status;
    error.data = data;
    throw error;
  }

  return data;
};

export const httpClient = {
  get: async (path, { query, headers } = {}) => {
    const url = buildUrl(path, query);
    const res = await fetch(url, {
      method: 'GET',
      headers: buildHeaders(headers),
      credentials: 'include',
    });
    return handleResponse(res);
  },
  post: async (path, body, { headers, query } = {}) => {
    const url = buildUrl(path, query);
    const res = await fetch(url, {
      method: 'POST',
      headers: buildHeaders(headers),
      body: body instanceof FormData ? body : JSON.stringify(body ?? {}),
      credentials: 'include',
    });
    return handleResponse(res);
  },
  put: async (path, body, { headers, query } = {}) => {
    const url = buildUrl(path, query);
    const res = await fetch(url, {
      method: 'PUT',
      headers: buildHeaders(headers),
      body: body instanceof FormData ? body : JSON.stringify(body ?? {}),
      credentials: 'include',
    });
    return handleResponse(res);
  },
  del: async (path, { headers, query } = {}) => {
    const url = buildUrl(path, query);
    const res = await fetch(url, {
      method: 'DELETE',
      headers: buildHeaders(headers),
      credentials: 'include',
    });
    return handleResponse(res);
  },
};

export default httpClient;
